import { Divider, Stack, styled } from "@mui/material";
import {
  Img,
  SmTextSemibold,
  XsText,
  XlTextSemiBold,
  TimeDiff,
} from "Components";
import { DIRECT_PATHS } from "constants/routes";
import CountryFlag from "Components/CountryFlag";
import { formatImgUrl } from "utils/helpers";
import Row from "Components/Row";
import { PlanChip } from "Components/Plan";
import { Link } from "Components/link";
import { COLORS } from "constants/layout";
import { useTranslation } from "hooks/useTranslation";
import { StarRating } from "Components/rating";
import React, { Fragment } from "react";
import useBreakpoints from "hooks/useBreakpoint";
import { useSupplierContext } from "..";
import SupplierVerfifyTooltip from "Components/tooltip/SupplierVerifyTooltip";
import ListingChip from "Components/chips/ListingChip";
import dayjs from "dayjs";
import { el } from "date-fns/locale";

const PaidBaseSupplierInfors = () => {
  const t = useTranslation();
  const { isMobile } = useBreakpoints();
  const { supplierDetail } = useSupplierContext();
  const NOW = dayjs();

  const {
    company_country,
    country_code,
    name,
    farm_avatar,
    farm_name,
    plan_name,
    trust_star,
    num_review = 0,
    num_inquiry = 0,
    num_view = 0,
    plan,
    activity_tags = [],
    last_active,
  } = supplierDetail || {};

  const counters = [
    { label: "review", mulLabbel: "reviews", value: num_review },
    { label: "inquiry", mulLabbel: "inquiries", value: num_inquiry },
    { label: "view", mulLabbel: "views", value: num_view },
  ].filter((counter) => counter.value > 0);

  return (
    <StyledBaseSupplierInfors spacing={1}>
      <Stack direction="row" spacing={{ xs: 1, md: 2 }}>
        {farm_avatar && (
          <Img
            src={formatImgUrl(farm_avatar, 2)}
            alt="img"
            className="company_img"
          />
        )}
        <Stack
          spacing={1}
          flex={1}
          maxWidth={`calc(100% - ${farm_avatar ? "100px" : "0px"})`}
        >
          {farm_name && (
            <Row spacing={1} className="title-company">
              <Link to={DIRECT_PATHS.companyDetail(name)} >
                <XlTextSemiBold
                  className="company_name ellipsis-text"
                  component="h1"
                >
                  {farm_name}
                </XlTextSemiBold>
              </Link>
              {!isMobile && <PlanChip plan={plan_name} height={20} />}
            </Row>
          )}

          {/* Rating & counter */}
          {!isMobile && (
            <Stack direction={{ xs: "column", md: "row" }} spacing={1}>
              {/* Rating section */}
              <Row spacing={1} className="rating-box">
                <StarRating readOnly value={trust_star || 0} />
                <SmTextSemibold color="#FFCB45">
                  {(trust_star || 0).toFixed(1)}/5
                </SmTextSemibold>
              </Row>

              <Row spacing={1}>
                {counters.map((counter, i) => (
                  <React.Fragment key={counter.label}>
                    {!(isMobile && i === 0) && (
                      <Divider orientation="vertical" flexItem />
                    )}
                    <XsText color={COLORS.green[700]}>
                      <span style={{ fontWeight: 500 }}>{counter.value}</span>{" "}
                      {t(counter.value > 1 ? counter.mulLabbel : counter.label)}
                    </XsText>
                  </React.Fragment>
                ))}
              </Row>
            </Stack>
          )}

          <Row spacing={0.5} mb={0.5} minHeight={20}>
            {isMobile && <PlanChip plan={plan_name} height={15} />}
            <SupplierVerfifyTooltip data={plan} />
            <CountryFlag fd_country={company_country} {...{ country_code }} />
          </Row>

          {!isMobile && <ListingChip tags={activity_tags} />}
        </Stack>
      </Stack>

      {isMobile && (
        <Fragment>
          {last_active && (
            <XsText className="active-text" color={COLORS.gray[600]}>
              {t("active_value_ago", {
                value: (
                  <TimeDiff
                    endTime={NOW.format()}
                    startTime={dayjs(last_active).format()}
                  />
                ),
              })}
            </XsText>
          )}
          <ListingChip tags={activity_tags} />
        </Fragment>
      )}
    </StyledBaseSupplierInfors>
  );
};

const StyledBaseSupplierInfors = styled(Stack)(({ theme }) => ({
  fontSize: 16,
  width: "100%",
  ".company_name": {
    color: "#1D2939",
    span: { color: COLORS.gray[600], fontSize: 12, fontWeight: 400 },
    whiteSpace: "normal",
    overflow: "auto",
    ellipsis: "none",
    workBreak: "break-all",
  },
  ".title-company": {
    marginRight: 10,
  },
  ".company_img": {
    width: 100,
    height: 100,
    objectFit: "contain",
  },
  ".flag": {
    width: 16,
    height: 16,
  },
  ".tag-chip": {
    backgroundColor: COLORS.gray[100],
    color: COLORS.gray[700],
  },
  [theme.breakpoints.down("md")]: {
    ".company_img": {
      width: 40,
      height: 40,
    },
    ".rating-box": {
      p: {
        fontSize: 12,
      },
    },
    ".company_name": {
      fontSize: 16,
    },
  },
}));

export default PaidBaseSupplierInfors;
